// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"115":"d985073c35463ca0","188":"e0bb43cb4fda3fc0","538":"c17fc769170c40d3","682":"5eea61f1d8fd0de4","978":"e901ca14ec1acca2","983":"8795671031d00fb9"}[chunkId] + ".js";
};